import { Icon, MenuItem, Select } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import clsx from 'clsx'
import { getDatePickerDisplayFormat, getLocalizedDate } from 'commons/date'
import moment from 'moment'
import React from 'react'
import { filterOptions } from './useVoucherDataDetails'
import { useIntl } from 'react-intl'
import LocalizedDatePickerProvider from 'app/components/datepickers/LocalizedDatePickerProvider'
import LocalizedDatePickerToolbar from 'app/components/datepickers/LocalizedDatePickerToolbar'

const DATEPICKER_NAME = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
}

const getMinDateDatePicker = (filterOption, filter) => {
  if (filterOption.name !== DATEPICKER_NAME.END_DATE) return {}
  if (!filter[DATEPICKER_NAME.START_DATE]) return {}
  return { minDate: moment(filter[DATEPICKER_NAME.START_DATE]) }
}

const getMaxDateDatePicker = (filterOption, filter) => {
  if (filterOption.name !== DATEPICKER_NAME.START_DATE) return {}
  if (!filter[DATEPICKER_NAME.END_DATE]) return {}
  return { maxDate: moment(filter[DATEPICKER_NAME.END_DATE]) }
}

export function FilterList({ classes, filter, onChangeFilterByKey }) {
  const { formatMessage } = useIntl()

  return filterOptions.map((filterOption) => {
    if (filterOption.type === 'DatePicker') {
      return (
        <div
          className={clsx('relative sm:ltr:mr-8 rtl:ml-8', classes.datePicker)}
          key={filterOption.name}
        >
          <LocalizedDatePickerProvider>
            <DatePicker
              clearable
              emptyLabel={filterOption}
              inputVariant="outlined"
              className={clsx('mb-8 sm:mb-0 w-full sm:min-w-216')}
              value={
                filter[filterOption.name]
                  ? moment(filter[filterOption.name])
                  : null
              }
              labelFunc={(date) => {
                return `${formatMessage({ id: filterOption.placeHolder })} ${
                  date ? getLocalizedDate(date, 'DATE') : ''
                }`
              }}
              {...getMinDateDatePicker(filterOption, filter)}
              {...getMaxDateDatePicker(filterOption, filter)}
              format={getDatePickerDisplayFormat()}
              onChange={onChangeFilterByKey(filterOption.name)}
              ToolbarComponent={LocalizedDatePickerToolbar}
              okLabel={formatMessage({ id: 'date.picker.ok' })}
              cancelLabel={formatMessage({ id: 'date.picker.cancel' })}
              clearLabel={formatMessage({ id: 'date.picker.clear' })}
            />
            <Icon className={classes.selectIcon}>keyboard_arrow_down_icon</Icon>
          </LocalizedDatePickerProvider>
        </div>
      )
    }
    if (filterOption.type === 'Select') {
      return (
        <Select
          className={clsx(classes.statusSelect, 'sm:ltr:mr-8 rtl:ml-8')}
          value={filter[filterOption.name]}
          onChange={onChangeFilterByKey(filterOption.name)}
          key={filterOption.name}
          IconComponent={() => (
            <Icon className={classes.selectIcon}>keyboard_arrow_down_icon</Icon>
          )}
        >
          {filterOption.options.map((option) => {
            return (
              <MenuItem key={option.value} value={option.value}>
                {formatMessage({ id: option.title })}
              </MenuItem>
            )
          })}
        </Select>
      )
    }
    return null
  })
}
